import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { Grid, Divider, OutlinedInput, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import DiscountContext from "../../../context/discounts/DiscountContext";

// Components
import Delete from "./confirmation/Delete";

const useStyles = makeStyles(() => ({
  input: {
    fontSize: "0.9rem",
    backgroundColor: "white",
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
  button2: {
    color: "white",
    backgroundColor: "#dc004e",
    "&:hover": {
      backgroundColor: "#dc004e",
    },
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DiscountActions = ({ fieldsValidation, onChangePage, changeUrl }) => {
  const classes = useStyles();

  const {
    display_content,
    discounts_filtered,
    selected_discount,
    form_data,
    form_error,
    setDisplayContent,
    filterDiscounts,
    clearFilteredDiscounts,
    createDiscount,
    updateDiscount,
    setFormError,
  } = useContext(DiscountContext);

  const searchText = useRef("");
  const [openDelete, setOpenDelete] = useState(false);

  const formValidation = (action) => {
    // Error Checking
    let noError = true;
    Object.values(form_error).map((each) => {
      if (each) noError = false;
    });

    // Field Checking
    let filled = true;
    Object.entries(form_data).map(([key, value]) => {
      if (key === "discount_include") {
        if (value.length < 1) {
          filled = false;
          form_error[key] = "Select at least ONE store!";
        }
      } else {
        if (value === "") {
          filled = false;
          form_error[key] = "Field cannot be empty!";
        }
      }
    });

    // Value Checking
    let changes = false;
    if (action === "update") changes = fieldsValidation(selected_discount);

    // Valid To Submit
    let valid = false;
    if (noError && filled) valid = true;
    else setFormError(form_error);

    return {
      valid,
      changes,
    };
  };

  const onSearch = (e) => {
    if (searchText.current.value) {
      searchText.current.value = searchText.current.value
        .toUpperCase()
        .replace(/ /g, "");

      filterDiscounts(e.target.value.replace(/ /g, ""));
    } else {
      clearFilteredDiscounts();
    }
  };

  const onCreate = () => {
    setDisplayContent("Create");
    changeUrl("onCreate", "/discount/create");
  };

  const onSave = (action) => {
    const { valid, changes } = formValidation(action);

    if (valid) {
      if (action === "create") createDiscount();
      if (action === "update") updateDiscount(changes);
    }
  };

  const onDelete = () => setOpenDelete(true);

  const onCancel = () => onChangePage();

  useEffect(() => {
    if (!discounts_filtered) searchText.current.value = "";
  });

  return (
    <Fragment>
      {" "}
      {selected_discount && (
        <Delete openDeleteState={[openDelete, setOpenDelete]} />
      )}
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>
      <Grid item xs={12} container>
        {" "}
        {/* Search Bar */}{" "}
        <Grid item xs={2} container justifyContent="flex-start" alignItems="center">
          <Grid item xs={12}>
            <OutlinedInput
              fullWidth
              type="text"
              margin="dense"
              className={classes.input}
              id="search_text"
              placeholder="Discount Code"
              autoFocus={!display_content}
              inputRef={searchText}
              onChange={onSearch}
            />{" "}
          </Grid>{" "}
        </Grid>
        {/* Buttons - Behind */}{" "}
        <Grid item xs container justifyContent="flex-end" alignItems="center">
          {" "}
          {display_content === "" ? (
            <Grid item className={classes.buttonBox}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onCreate}
              >
                New Discount{" "}
              </Button>{" "}
            </Grid>
          ) : (
            <Fragment>
              <Grid item className={classes.buttonBox}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  onClick={onCancel}
                >
                  Cancel{" "}
                </Button>{" "}
              </Grid>
              {display_content === "Create" && (
                <Grid item className={classes.buttonBox}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() => onSave("create")}
                  >
                    Create{" "}
                  </Button>{" "}
                </Grid>
              )}
              {display_content === "Edit" && selected_discount && (
                <Fragment>
                  <Grid item className={classes.buttonBox}>
                    <Button
                      fullWidth
                      variant="contained"
                      className={classes.button2}
                      onClick={onDelete}
                    >
                      Delete{" "}
                    </Button>{" "}
                  </Grid>
                  <Grid item className={classes.buttonBox}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() => onSave("update")}
                    >
                      Save{" "}
                    </Button>{" "}
                  </Grid>{" "}
                </Fragment>
              )}{" "}
            </Fragment>
          )}{" "}
        </Grid>{" "}
      </Grid>
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>{" "}
    </Fragment>
  );
};

export default DiscountActions;
